import { useState } from "react";
import { PageHeader, Tabs } from "@/components/Kit";
import ItemsTab from "./inventory/ItemsTab";
import IssuesTab from "./inventory/IssuesTab";
import StockReportTab from "./inventory/StockReportTab";
import { BookCopy, ArrowLeftRight, BarChart3 } from "lucide-react";

export default function Inventory() {
  const [tab, setTab] = useState("items");
  return (
    <div data-testid="inventory-page">
      <PageHeader title="Notebook & Textbook Inventory" subtitle="Item masters, stock-in, issue/return to students and lost-book fines" />
      <Tabs testid="inv-tabs" active={tab} onChange={setTab} tabs={[{ key: "items", label: "Item Masters", icon: BookCopy }, { key: "issues", label: "Issue & Return", icon: ArrowLeftRight }, { key: "report", label: "Stock Report", icon: BarChart3 }]} />
      {tab === "items" && <ItemsTab />}
      {tab === "issues" && <IssuesTab />}
      {tab === "report" && <StockReportTab />}
    </div>
  );
}
